import SysErrorCodesList from "../component/SysErrorCodesList";
import React from "react";

const SysErrorCodesListContainer = () => (<SysErrorCodesList />)

export default SysErrorCodesListContainer;